<template>
  <div v-loading="loading" :style="{height: this.data.length === 0 ? 'calc(100vh - 76px)' : 'auto'}">
    <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
    <el-button class="to-bottom" circle icon="el-icon-caret-bottom" @click="scrollToBottom"></el-button>
    <div ref="scrollContainer" class="container mb-4" :class="{'h-100':this.data.length === 0}" :style="{height: loading ? '100vh' : 'auto'}">
        <el-backtop></el-backtop>
        <div class="my-3" :style="isphone ? 'margin: 0 auto;' :'width:1080px; margin: 0 auto;'">
            <div class="fs-4" v-if="this.dateParams !== undefined && this.dateParams !== ' '">
                {{ this.dateStr }}
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="this.dateParams == undefined || this.dateParams == ''">
                <div>
                    <span>日期：</span>
                    <el-date-picker
                        v-model="dateVal"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="changeDate">
                    </el-date-picker>
                </div>
                <div class="d-flex">
                    <!-- <el-switch
                    v-model="tbVal"
                    active-text="elm表格"
                    inactive-text="bootstrap表格">
                    </el-switch> -->
                    <div class="me-2">
                        <el-button plain type="primary" @click="centerDialogVisible = true">联赛选择</el-button>
                        <el-dialog title="联赛选择" :visible.sync="centerDialogVisible" width="90%" center>
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                            <el-checkbox v-model="checkMyLeague1" @change="handleCheckMyLeague1">竞足</el-checkbox>
                            <el-checkbox v-model="checkMyLeague2" @change="handleCheckMyLeague2">北单</el-checkbox>
                            <el-checkbox v-model="checkMyLeague3" @change="handleCheckMyLeague3">其他</el-checkbox>
                            <div style="max-height: 50vh; overflow-y: scroll;">
                            <el-checkbox-group v-model="checkedLeague" @change="handleCheckedLeagueChange">
                                <el-checkbox v-for="(item,index) in league" :label="item" :key="index" @change="change(index,item)">{{item}}</el-checkbox>
                            </el-checkbox-group></div>
                            <span slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="filterLg">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div>
                    <!-- <div class="me-2">
                        <el-button plain type="primary" @click="captureUxGrid">截图表格</el-button>
                    </div> -->
                    <el-button plain type="primary" @click="hideNoData">剔除无数据</el-button>
                    <el-button plain type="primary" @click="modSwitch"> {{tbVal ? '盘口模式' : '纯净模式'}}</el-button>
                    <el-button plain type="primary" @click="toggleHFA"> {{isHFA ? '中立' : 'HFA'}}</el-button>
                </div>
            </div>
            <!-- <span class="fs-4">{{ this.dateStr }}</span>
            <router-link :to="'/qsda-today'" class="text-primary" style="cursor: pointer;">查看今日比赛>></router-link> -->
        </div>
        <!-- <div class="mb-4 text-center" :class="{'h-100':this.data.length === 0}" v-if="this.data.length === 0 && !loading">
            <div class="nodata d-flex flex-column justify-content-center" :class="{'h-100':this.data.length === 0}">
                <span class="align-center">暂无比赛数据</span>
            </div>
        </div> -->
        <div class="d-flex justify-content-center" :class="{'h-100':this.data.length === 0}">
            <div :style="isphone ? 'overflow-x:scroll' :'width:1080px; margin: 0 auto;'">
                <div v-show="!tbVal">
                    <table class="table table-striped table-bordered table-hover">
                        <thead style="background-color: #fafafa;">
                            <tr class="text-secondary">
                                <th scope="col" class="fs-14 text-center py-1">#</th>
                                <th scope="col" class="fs-14 text-center py-1">联赛</th>
                                <th scope="col" class="fs-14 text-center py-1">时间</th>
                                <th scope="col" class="fs-14 text-end py-1">主队</th>
                                <th scope="col" class="fs-14 text-center py-1">-</th>
                                <th scope="col" class="fs-14 py-1">客队</th>
                                <th scope="col" class="fs-14 text-center py-1">盘口</th>
                                <th scope="col" class="fs-14 text-center py-1">窄实/火力</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in this.data" :key="index" :class="{ 'active-row': activeIndex === index }" @click="activeIndex = index">
                                <td class="p-0 fs-14 text-center" style="width: 40px;line-height: 48px;">{{ index+1 }}</td>
                                <td class="text-white text-center fs-14 p-0" :style="{background: item.color, width: '100px'}" style="line-height: 64px;">{{ item.league }}</td>
                                <td style="width: 60px;line-height: 48px;">{{ item.time }}</td>
                                <td>
                                    <div class="text-end" style="line-height: 48px;">
                                        <sup><font class="fs-12 me-1">{{ item.home_rank }}</font></sup>
                                        <span>{{ item.home }}</span>
                                    </div>
                                </td>
                                <td class="text-center" style="width: 40px;line-height: 48px;">-</td>
                                <td>
                                    <div style="line-height: 48px;">
                                        <span>{{ item.away }}</span>
                                        <sup><font class="fs-12 ms-1">{{ item.away_rank }}</font></sup>
                                    </div>
                                </td>
                                <td class="text-center fs-14 text-primary" style="width: 90px; max-width: 90px; line-height: 26px;">
                                    <a :href="'https://zq.titan007.com/analysis/'+item.id+'cn.htm'" target='_blank' class="text-decoration-none">
                                        <div>{{ item.handicap.replace('受', '*') }}</div>
                                        <div>{{ item.bigsmall }}</div>
                                    </a>
                                </td>
                                <td class="text-center qsda qsdaColor font-weight-bold" style="width: 80px; line-height: 26px;">
                                    <div :style="{color: qsdaColorSet(item.handicap,Math.round((item.hxg-item.axg)*100))}">{{ (item.hxg ===null || item.axg === null) || (item.hxg ===0 && item.axg ===0) ? '' : qsdaVal(item.hxg,item.hfa,item.axg) }}</div>
                                    <div :style="{color: bsColorSet(item.bigsmall,bsVal(item.hxg + item.axg))}">{{ (item.hxg ===null && item.axg === null)||item.hxg ===0 && item.axg === 0 ? '' : bsVal(item.hxg + item.axg) }}</div>
                                </td>
                                <!-- <td class="text-center qsda qsdaColor font-weight-bold" :style="{color: bsColorSet(item.bigsmall,bsVal(item.hxg + item.axg))}">{{ (item.hxg ===null && item.axg === null)||item.hxg ===0 && item.axg === 0 ? '' : bsVal(item.hxg + item.axg) }}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-show="tbVal">
                    <ux-grid
                        ref="table"
                        style="width: 100%"
                        stripe
                        show-overflow
                        use-virtual
                        :widthResize = 'true'
                        :empty-text = this.emptyText
                        :data = data
                        :highlightCurrentRow="true"
                        show-header-overflow="ellipsis">
                            <ux-table-column type="index" :width="40"/>
                            <ux-table-column :width="100" field="league" title="联赛" :filters="filters" :filter-method="filterTag">
                                <template v-slot="scope">
                                    <div class="text-white text-center" :style="{background: scope.row.color, padding: '0 8px'}">
                                        <a :href="'https://zq.titan007.com/cn/SubLeague.aspx?SclassID='+scope.row.lid" target='_blank' class="text-decoration-none">{{scope.row.league}}</a></div>
                                </template>
                            </ux-table-column>
                            <ux-table-column :width="60" field="time" title="时间"></ux-table-column>
                            <ux-table-column :width="isphone ? 180 : ''" field="home" title="主队">
                                <template v-slot="scope">
                                    <sup><font>{{ scope.row.home_rank }}</font></sup>
                                    <router-link :to="{ path: '/charts/' + scope.row.id, query: { teams: scope.row.home+' VS '+scope.row.away, hxg:undefined==scope.row.hfa || null==scope.row.hfa ? scope.row.hxg : scope.row.hxg, axg:scope.row.axg,hfa: scope.row.hfa} }" class="my-2 text-decoration-none ps-1" tag="a" target="_blank">{{ scope.row.home }}</router-link>
                                </template>
                            </ux-table-column>
                            <ux-table-column :width="60" field="-" title="-">
                                <template>
                                    <span>-</span>
                                </template>
                            </ux-table-column>
                            <ux-table-column :width="isphone ? 180 : ''" field="away" title="客队">
                                <template v-slot="scope">
                                    {{ scope.row.away }}
                                    <sup><font>{{ scope.row.away_rank }}</font></sup>
                                </template>
                            </ux-table-column>
                            <!-- <ux-table-column :width="60" field="index1" title="指数1">
                                <template v-slot="scope">
                                    <div class="d-flex flex-column">
                                        <span style='color:#880000;'>{{ scope.row.index1 }}</span>
                                        <span>{{ scope.row.big }}</span>
                                    </div>
                                </template>
                            </ux-table-column> -->
                            <!-- <ux-table-column :width="100" field="handicap" title="让/受">
                                <template v-slot="scope">
                                    <div class="d-flex flex-column">
                                        <span style='color:#880000;'>{{ handicapToNum(scope.row.handicap) }}</span>
                                        <span>{{ scope.row.bigsmall }}</span>
                                    </div>
                                </template>
                            </ux-table-column> -->
                            <!-- <ux-table-column :width="60" field="index2" title="指数2">
                                <template v-slot="scope">
                                    <div class="d-flex flex-column">
                                        <span style='color:#880000;'>{{ scope.row.index2 }}</span>
                                        <span>{{ scope.row.small }}</span>
                                    </div>
                                </template>
                            </ux-table-column> -->
                            
                            <ux-table-column :width="85" field="qsda" title="窄实">
                                <template v-slot="scope">
                                    <a :href="'https://zq.titan007.com/analysis/'+scope.row.id+'cn.htm'" target='_blank' class="text-decoration-none font-weight-bold d-flex flex-column">
                                        <span class="qsda qsdaColor" :style="{color: qsdaColorSet(scope.row.handicap,Math.round((scope.row.hxg-scope.row.axg)*100))}">{{ (scope.row.hxg ===null || scope.row.axg === null) || (scope.row.hxg ===0 && scope.row.axg ===0) ? '' : Math.round((scope.row.hxg-scope.row.axg)*100)  }}</span>
                                    </a>
                                </template>
                            </ux-table-column>
                            <ux-table-column :width="80" field="huoli" title="火力值">
                                <template v-slot="scope">
                                    <div class="text-decoration-none font-weight-bold d-flex flex-column">
                                        <span class="qsda qsdaColor" :style="{color: bsColorSet(scope.row.bigsmall,bsVal(scope.row.hxg + scope.row.axg))}">{{ (scope.row.hxg ===null && scope.row.axg === null)||scope.row.hxg ===0 && scope.row.axg === 0 ? '' : bsVal(scope.row.hxg + scope.row.axg) }}</span>
                                    </div>
                                </template>
                            </ux-table-column>
                            <ux-table-column :width="60" field="hfa" title="HFA">
                                <template v-slot="scope">
                                        <span class="qsda qsdaColor" :style="{color: qsdaColorSet(scope.row.handicap,Math.round((scope.row.hxg*(1+scope.row.hfa)-scope.row.axg*(1-scope.row.hfa)) * 100))}">{{ scope.row.hfa !== null ? Math.round((scope.row.hxg*(1+scope.row.hfa)-scope.row.axg*(1-scope.row.hfa)) * 100) : '-' }}</span>
                                </template>
                            </ux-table-column>
                            <!-- <ux-table-column :width="60" field="poisson" title="概率">
                                <template v-slot="scope">
                                    <div class="d-flex flex-column">
                                        <span class="fs-10" style="line-height: 16px;" v-for="(poisson,index) in scope.row.poisson" :key="index">{{ poisson.score }}</span>
                                    </div>
                                </template>
                            </ux-table-column> -->
                    </ux-grid>
                </div>
            </div>
        </div>
    </div>
    <div class="p-3"></div>
    <Footer></Footer>
  </div>
</template>

<script>
import {setcolor } from '@/utils/setcolor';
import { checkColor, handicapToNum, convertToReal, compare, dateFormatted,isMobile, bsConvervToNum, qsdaVal } from '../utils/utils'
import { getFbZsMatches, getGuoCaiLeague, getMatchUrl } from '../constants/http.config'
import Nav from './comment/nav.vue'
import Footer from './comment/footer.vue'
import { toPng } from 'html-to-image';
export default {
    inject: ['reload'],
    components: { Nav,Footer },
    data() {
        return {
            matches: [],
            data: [],
            filters: [],
            allLg: [],//所有联赛，包括重复的
            myLeague1: [],//竞足
            myLeague2: [],//北单
            myLeague3: [],//非北单
            isHide: [],
            // poissonList: [],
            goalList: [0,1,2,3,4,5,6,7,8,9,10],
            emptyText: '数据加载中...',
            isDark: false,
            isToday: true,
            isTomorrow: false,
            loading: true,
            isphone: false,
            isStable: false,
            tbVal: true,
            dateStr: '',
            currentDate: 0,
            dateParams: '',
            dateVal: '',
            isIndeterminate: false,
            checkAll: true,
            checkMyLeague1: false,
            checkMyLeague2: false,
            checkMyLeague3: false,
            checkedLeague: [],
            checkedLeagueVal: [],
            centerDialogVisible: false,
            isSel: false,
            isHFA: false,
            league: [],//当前数据不重复的联赛
            filterData: [],
            unshiftLeague: [],
            selectedLg: [],
            activeIndex: null, // 初始不选中任何行
        }
    },
    mounted() {
        this.dateParams = this.$route.params.date;
        this.dateStr = this.$route.params.date;
        if(this.isMobile() === 'mobile'){
            this.isphone = true;
        }
        if(this.isMobile() === 'tablet'){
            this.ispad = true;
        }
        // this.getCheckLeague();
        this.getData();
    },
    methods: {
        setcolor,
        dateFormatted,
        handicapToNum,
        checkColor,
        convertToReal,
        compare,
        isMobile,
        bsConvervToNum,
        callSetColor(color,league){
            return setcolor(color,league);
        },
        qsdaColorSet(handicap,qsda){
            let qsdaColor = 'rgb(128,0,255)';
            let lowOrHight = 2;
            if (handicap!=='') {
                const handicapNum = handicapToNum(handicap);
                const realHandicapNum = convertToReal(qsda);
                if (handicapNum === 0) {
                    qsdaColor = 'rgb(128,0,255)';
                    return qsdaColor
                }else{
                    if (typeof handicapNum !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                            lowOrHight = compare(handicapNum, realHandicapNum);
                        if(lowOrHight === 0){
                            qsdaColor = '#666';
                            return qsdaColor
                        }
                        if (lowOrHight === 1) {
                            qsdaColor = 'red';
                            return qsdaColor
                        }
                        if (lowOrHight === -1) {
                            qsdaColor = 'green';
                            return qsdaColor
                        }
                    }
                }
            }
        },
        fetchData(url){
            fetch(url)
            .then(response => response.json())
            .then(data => {
                this.loading = false;
                this.matches = data.data;
                this.data = this.matches;
                // console.log(data.data);
                
                // this.dateStr = data.data.length > 0 ? data.data[0].date : ''
                if (data.data.length == 0) {
                    this.emptyText = '暂无数据';
                }else{
                    this.emptyText = '加载中...';
                    //剔除没xg数据的
                    // const filterdata = this.data.filter(item =>(item.hxg !== 0 && item.hxg !== null) && (item.axg !== 0 && item.axg !== null));
                    // this.data = filterdata;
                    const leagueSet = new Set(this.data.map((item) => item.league));
                    const leagueArray = Array.from(leagueSet);
                    this.league = leagueArray.map((item) => (item));
                    this.checkedLeague = this.league;
                    for (let index = 0; index < this.checkedLeague.length; index++) {
                        // const element = this.checkedLeague[index];
                        this.checkedLeagueVal.push(true);
                    }
                    // console.log('1211',this.checkedLeagueVal,this.checkedLeague);
                    this.data.forEach(item => {
                        this.isHide.push(false);
                        this.allLg.push(item.league);
                        const homeXg = item.hxg;
                        const awayXg = item.axg;
                        // console.log(item.home,item.away,homeXg,awayXg,homeXg !== 0 && awayXg !== 0);
                        
                        let poissonList = []; // 在每次循环开始时重新初始化
                        // if ( homeXg !== 0 && awayXg !== 0 ) {
                            for (let i = 0; i < this.goalList.length; i++) {
                                const elm = this.goalList[i];
                                const h = this.poissonDist(elm, homeXg, false);
                                const a = this.poissonDist(elm, awayXg, false);
                                const res = {
                                    id: item.id, home: h, away: a
                                }
                                poissonList.push(res);
                            }
                            const res = this.calculateScores(poissonList);
                            item.poisson = res;
                            // console.log(item.poisson);
                        // }
                    })
                    // console.log('1111',this.allLg.length);
                    // console.log(this.data[0]);
                }
                this.getCheckLeague();
                this.$refs.table.reloadData(this.data);
                
            }).catch(err=>{
                this.loading = false;
                console.log('读取数据出错',err);
            })
        },
        getData(){
            let date = dateFormatted(new Date());
            this.dateVal = date;
            if (this.dateParams !== undefined) {
                date = this.dateParams;
            }else{
                // 设置目标时间为 10:30 AM
                let targetTime = new Date();
                let currentTime = new Date();
                targetTime.setHours(10);
                targetTime.setMinutes(35);
                targetTime.setSeconds(0);
                // 比较当前时间和目标时间
                if (currentTime > targetTime) {
                    // console.log("当前时间大于 10:35 AM，读取今日数据");
                    date = this.dateFormatted(currentTime);
                } else {
                    // console.log("当前时间小于 10:35 AM，读取昨天数据");
                    // 将日期减一天
                    currentTime.setDate(currentTime.getDate() - 1)
                    date = this.dateFormatted(currentTime);
                    // console.log(dateParams);
                }
            }
            // const url = '/football/match/' + date;
            const url = getFbZsMatches + date;
            // console.log(url);
            this.fetchData(url)
        },
        filterTag({value, row, column}) {
            const property = column['property'];
            // console.log(property,row[property],row[property] === value);
            if (value === '竞足') {
                // 当选择 '竞足' 时，检查 myLeague1 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague1.some(league => row[property] === league);
                return match;
            }else if(value === '北单'){
                // 当选择 '北单' 时，检查 myLeague2 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague2.some(league => row[property] === league);
                return match;
            }else if(value === '非北单'){
                // 当选择 '非北单' 时，检查 myLeague2 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague3.some(league => row[property] === league);
                return match;
            }else{
                // 重置 ishide 数组
                // this.ishide.forEach((_, index) => {
                //     this.ishide[index] = false;
                // });
                return row[property] === value;
            }
        },
        updateFilterEvent(){
            // console.log('update11111');
            
            // this.getCheckLeague();
            const column = this.$refs.table.getColumnByField('league')
            const leagueSet = new Set(this.data.map((item) => item.league));
            const leagueArray = Array.from(leagueSet);
            this.filters = leagueArray.map((item) => ({ label: item, value: item }));
            if (this.myLeague3.length > 0) {
                // console.log('6666',this.myLeague3.length);
                
                this.filters.unshift({label: '非北单', value: '非北单'})
            }
            if (this.myLeague2.length > 0) {
                // console.log('7777',this.myLeague2.length);
                this.filters.unshift({label: '北单', value: '北单'})
            }
            if (this.myLeague1.length > 0) {
                // console.log('8888',this.myLeague1.length);
                this.filters.unshift({label: '竞足', value: '竞足'})
            }
            // console.log(this.filters,'wwwww');
            this.$refs.table.setFilter(column, this.filters)
            this.$refs.table.updateData();
            // console.log('wwwww',this.allLg,this.myLeague1,this.myLeague2,this.myLeague3,this.league,this.filterData)
        },
        //获取国彩联赛列表
        async getCheckLeague(){
            const url = getGuoCaiLeague;
            //const url = 'https://api.qsda.net/api/league/check-league';
            const today = this.dateFormatted(new Date());
            // console.log(today);
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log(data.data);
                this.myLeague1 = data.data[0].data;
                this.myLeague2 = data.data[1].data;
                this.myLeague3 = this.allLg.filter(item => !this.myLeague2.includes(item));
                const filterLg3 = [...new Set(this.myLeague3)];
                this.myLeague3 = filterLg3;
                // console.log(this.myLeague1.length, this.myLeague2.length, this.myLeague3.length);
                // console.log('9999',this.myLeague3);
                this.updateFilterEvent();
            }).catch(err=>{
                console.log('读取数据出错',err);
            });
        },
        scrollToBottom() {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        },
        factorial(n) {
            if (n === 0 || n === 1) return 1;
            let result = 1;
            for (let i = 2; i <= n; i++) {
                result *= i;
            }
            return result;
        },
        poissonDist(x, mean, cumulative = false) {
            if (cumulative) {
                // 计算累计概率
                let cumulativeProb = 0;
                for (let k = 0; k <= x; k++) {
                    cumulativeProb += (Math.pow(mean, k) * Math.exp(-mean)) / this.factorial(k);
                }
                return cumulativeProb;
            } else {
                // 计算单点概率
                return (Math.pow(mean, x) * Math.exp(-mean)) / this.factorial(x);
            }
        },
        calculateScores(data) {
            let results = [];
            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < data.length; j++) {
                let value = Math.round((data[i].home * data[j].away * 10000))/10000;
                if (value >= 0.01) {
                    let key = `${i}-${j}`;
                    results.push({ score: key, value: value });
                }
                }
            }
            // 最高到低排序
            results.sort((a, b) => b.value - a.value);
            // 仅保留最高的前三个值
            results = results.slice(0, 3);
            return results;
        },
        changeDate(){
            const date = this.dateVal;
            this.data = [];
            // const url = '/football/match/' + date;
            const url = getFbZsMatches + date;
            // console.log(url);
            this.fetchData(url);
        },
        //大小球换算
        bsVal(value){
            // 保留两位小数
            const roundedValue = Math.round(value * 100) / 100;
            const decimalPart = roundedValue % 1; // 获取小数部分
            //  console.log('kkkkkk',value,roundedValue);
            // 对正数处理
            if (decimalPart <= 0.125) {
                // console.log('decimalPart < 0.125',roundedValue,decimalPart,Math.floor(roundedValue));
                return Math.floor(roundedValue); // 小数 <= 0.25 算 0
            } else if (decimalPart > 0.125 && decimalPart <= 0.25) {
                // console.log('decimalPart > 0.125 && decimalPart <= 0.25',roundedValue,decimalPart,Math.floor(roundedValue) + 0.25);
                return Math.floor(roundedValue) + 0.25; // 小数 > 0.125 且 <= 0.25 算 0.25
            } else if (decimalPart > 0.25 && decimalPart <= 0.625) {
                // console.log('decimalPart > 0.25 && decimalPart <= 0.625',roundedValue,decimalPart,Math.floor(roundedValue) + 0.5);
                return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.625 算 0.5
            } else if (decimalPart > 0.625 && decimalPart <= 0.875) {
                // console.log('decimalPart > 0.625 && decimalPart <= 0.875',roundedValue,decimalPart,Math.floor(roundedValue) + 0.75);
                return Math.floor(roundedValue) + 0.75; // 小数 > 0.625 且 <= 0.875 算 0.75
            } else if (decimalPart > 0.875 && decimalPart <= 1) {
                // console.log('decimalPart > 0.875 && decimalPart <= 1',roundedValue,decimalPart,Math.ceil(roundedValue));
                return Math.ceil(roundedValue); // 小数 > 0.875 且 <= 1 算 1
            }
        },
        bsColorSet(bigsmall,bs){
            let qsdaColor = 'rgb(128,0,255)';
            let bsNum = 0;
            if (bigsmall!=='') {
                if (bigsmall.includes('/')) {
                    bsNum = bsConvervToNum(bigsmall);
                }else{
                    bsNum = Number(bigsmall);
                }
                if (bs > bsNum) {
                    // console.log('浅开',bs, '>', bsNum);
                    qsdaColor = 'green';
                    return qsdaColor
                }
                if (bs < bsNum) {
                    // console.log('高开',bs, '<', bsNum);
                    qsdaColor = 'red';
                    return qsdaColor
                }
                if (bs === bsNum) {
                    // console.log('实开',bs, '=', bsNum);
                    qsdaColor = '#666';
                    return qsdaColor
                }
            }else{
                return qsdaColor
            }
            
        },
        handleCheckAllChange(val) {
            // console.log('000000',val,this.league);
            this.checkedLeague = val ? this.league : [];
            this.checkMyLeague1 = false;
            this.checkMyLeague2 = false;
            this.checkMyLeague3 = false;
            this.isIndeterminate = false;
            this.isSel = true;
            this.checkAll = val ? true : false;
            this.filterData = this.matches;
            //设置全选或全不选
            // for (let index = 0; index < this.checkedLeagueVal.length; index++) {
            //     if (val) {
            //         this.checkedLeagueVal[index] = false;
            //     }else{
            //         this.checkedLeagueVal[index] = true;
            //     }
            // }
        },
        handleCheckMyLeague1(val) {
            this.filterData = [];
            this.checkedLeague = val ? this.myLeague1 : [];
            console.log('111111',this.league);
            this.isSel = true;
            if (!val) {
                this.checkAll = true;
                this.checkedLeague = this.league;
                this.filterData = this.matches;
                // for (let index = 0; index < this.checkedLeagueVal.length; index++) {
                //     if (!val) {
                //         this.checkedLeagueVal[index] = false;
                //         console.log(this.checkedLeagueVal[index]);
                //     }else{
                //         this.checkedLeagueVal[index] = true;
                //         console.log(this.checkedLeagueVal[index]);
                //     }
                // }
            }else{
                this.checkAll = false;
                this.checkMyLeague2 = false;
                this.checkMyLeague3 = false;
                for (let index = 0; index < this.matches.length; index++) {
                    const elm = this.matches[index];
                    const all = this.matches[index].league;
                    let isMatchFound = false;
                    for (let i = 0; i < this.myLeague1.length; i++) {
                        const check = this.myLeague1[i];
                        if (check === all) {
                            console.log('fff');
                            // isMatchFound = true;
                            // break; // 找到匹配就可以跳出循环
                            this.filterData.push(elm);
                        }
                    }
                    this.checkedLeagueVal[index] = !isMatchFound; // 如果找到匹配值，则 isHide 为 false；否则为 true
                }
                console.log(this.filterData.length,'8888');
            }
        },
        handleCheckMyLeague2(val) {
            this.filterData = [];
            this.checkedLeague = val ? this.myLeague2 : [];
            console.log('222222',this.myLeague2);
            this.isSel = true;
            if (!val) {
                this.checkAll = true;
                this.checkedLeague = this.league;
                this.filterData = this.matches;
                // for (let index = 0; index < this.isHide.length; index++) {
                //     if (!val) {
                //         this.isHide[index] = false;
                //     }else{
                //         this.isHide[index] = true;
                //     }
                // }
            }else{
                this.checkAll = false;
                this.checkMyLeague1 = false;
                this.checkMyLeague3 = false;
                for (let index = 0; index < this.matches.length; index++) {
                    const elm = this.matches[index];
                    const all = this.matches[index].league;
                    let isMatchFound = false;
                    for (let i = 0; i < this.myLeague2.length; i++) {
                        const check = this.myLeague2[i];
                        if (check === all) {
                            this.filterData.push(elm);
                            // isMatchFound = true;
                            // break; // 找到匹配就可以跳出循环
                        }
                    }
                    this.isHide[index] = !isMatchFound; // 如果找到匹配值，则 isHide 为 false；否则为 true
                }
                console.log(this.filterData,'228888');
            }
        },
        handleCheckMyLeague3(val) {
            this.filterData = [];
            this.checkedLeague = val ? this.myLeague3 : [];
            // console.log('5556666',this.myLeague3);
            this.isSel = true;
            if (!val) {
                this.checkAll = true;
                this.checkedLeague = this.league;
                this.filterData = this.matches;
            }else{
                this.checkAll = false;
                this.checkMyLeague1 = false;
                this.checkMyLeague2 = false;
                let cout = 0;
                for (let index = 0; index < this.matches.length; index++) {
                    const elm = this.matches[index];
                    const all = this.matches[index].league;
                    let isMatchFound = false;
                    for (let i = 0; i < this.myLeague3.length; i++) {
                        const check = this.myLeague3[i];
                        if (check === all) {
                            // console.log('ffff',check,all);
                            cout ++;
                            this.filterData.push(elm);
                            // isMatchFound = true;
                            // break; // 找到匹配就可以跳出循环
                        }
                    }
                }
                console.log('33388888',cout,this.checkedLeagueVal,this.checkedLeague);
            }
        },
        handleCheckedLeagueChange(value) {
            console.log('qqqq',value.length, this.data.length,this.matches.length);
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.league.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.league.length;
            
            // for (let index = 0; index < this.data.length; index++) {
            //     const leagueName = this.data[index].name;
            //     // console.log(leagueName.includes(checkElm),checkElm,leagueName);
            //     for (let i = 0; i < value.length; i++) {
            //         const checkElm = value[i];
            //         if (!leagueName.includes(checkElm)) {
            //             this.filterData.unshift(elm);
            //             this.isHide[index] = true;
            //             console.log('yyy',checkElm,leagueName,this.isHide[index]);
            //         }
            //     }
            // }
        },
        change(i,league){
            this.checkedLeagueVal[i] = !this.checkedLeagueVal[i];
            console.log(i,league,this.checkedLeague.length);
            this.isSel = true;
            this.unshiftLeague = [];
            if (!this.checkedLeagueVal[i]) {
                // this.unshiftLeague.push(name);
                for (let index = 0; index < this.checkedLeague.length; index++) {
                    const elm = this.checkedLeague[index];
                    if (elm.league === league) {
                        this.checkedLeague.unshift(elm);
                    }
                }
                console.log('移除',this.checkedLeague.length);
            }else{
                for (let index = 0; index < this.checkedLeague.length; index++) {
                    const elm = this.checkedLeague[index];
                    if (elm.league === league) {
                        this.checkedLeague.push(elm);
                    }
                }
                console.log('添加',this.checkedLeague.length);
            }
            console.log('usss',this.unshiftLeague);
            
            // for (let index = 0; index < this.data.length; index++) {
            //     const elm = this.data[index];
            //     // console.log('000',elm,this.isHide[index]);
            //     if (name !== elm.name) {
            //         this.filterData.unshift(elm);
            //         // this.isHide[index] = !this.isHide[index];
            //         // console.log(index+1,elm.name);
            //     }
            // }
        },
        //重新加载数据
        filterLg(){
            console.log('confirm',this.checkedLeague);
            this.centerDialogVisible = false;
            this.filterData = [];
            // if (this.isSel) {
            if (this.checkAll) {
                this.filterData = this.matches;
            }else{
                for (let index = 0; index < this.matches.length; index++) {
                    const elm = this.matches[index];
                    const leagueName = this.matches[index].league;
                    for (let i = 0; i < this.checkedLeague.length; i++) {
                        const checkElm = this.checkedLeague[i];
                        if (leagueName.includes(checkElm)) {
                            this.filterData.push(elm);
                            // this.isHide[index] = true;
                            // console.log('yyy',checkElm,leagueName);
                        }
                    }
                }
            }
                this.data = [];
                this.data = this.filterData;
                this.$refs.table.updateData();
            // }
            
        },
        hideNoData(){
            // 剔除没xg数据的
            const filterdata = this.data.filter(item =>(item.hxg !== 0 || item.axg !== 0) && item.hxg !== null && item.axg !== null);
            this.data = filterdata;
            this.$refs.table.reloadData(this.data);
        },
        async modSwitch(){
            this.tbVal = !this.tbVal;
            // const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
            // await delay(1000);
            this.$refs.table.reloadData(this.data);
            this.$refs.table.updateData()
        },
        toggleHFA(){
            this.isHFA = !this.isHFA;
            // console.log('主场优势',this.isHFA);
        },
        async captureUxGrid() {
            try {
                const comp = this.$refs.table;
                const node = comp && comp.$el ? comp.$el : comp;
                if (!node) {
                    if (this.$message) this.$message.warning('找不到表格元素');
                    else alert('找不到表格元素');
                    return;
                }
                // 使用 html-to-image 将节点导出为 PNG
                const dataUrl = await toPng(node, { cacheBust: true, backgroundColor: '#ffffff', pixelRatio: 2 });
                const a = document.createElement('a');
                a.href = dataUrl;
                a.download = `ux-grid-${(new Date()).toISOString().slice(0,19).replace(/[:T]/g,'-')}.png`;
                a.click();
            } catch (err) {
                console.error('截图失败', err);
                if (this.$message) this.$message.error('截图失败');
                else alert('截图失败: ' + (err && err.message ? err.message : err));
            }
        },
        qsdaVal(hxg,hfa,axg){
            // console.log('主场优势',hfa);
            if (hfa !== null || hfa !== undefined || hfa !== 0) {
                if (this.isHFA) {
                    return Math.round((hxg*(1+hfa)-axg*(1-hfa)) * 100)
                }else{
                    return Math.round((hxg - axg) * 100)
                }
                
            }else{
                return Math.round((hxg-axg) * 100)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/sass/global.scss';
    .container{padding-bottom: 15px;}
    #scroll-container {position: fixed;}
    font {color: rgb(136, 136, 136);}
    .table {
        --bs-table-bg: none;
        --bs-table-color: none;
        td {padding: 0.5rem 0.75rem;}
        .td2 {--bs-table-bg-type: inherit;}
    }
    .active-row {
        background-color: #daf4ff !important; 
    }
    ::v-deep .elx-body--row .col_2 .elx-cell {padding: 0;}
    ::v-deep .elx-header--row .col_3 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_5 .elx-cell {justify-content: right;}
    ::v-deep .elx-header--row .col_6 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_9 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_8 .elx-cell {justify-content: center;}
    ::v-deep .elx-table--body-wrapper {font-size: 16px; color: #000;}
    ::v-deep .col_3 .elx-cell {padding: 0; line-height: 48px;}
    ::v-deep .elx-body--column { text-align: center!important; }
    ::v-deep .col_5 { text-align: right!important; }
    ::v-deep .col_7 { text-align: left!important; }
    // ::v-deep .elx-table.border--full .elx-table--header-wrapper { background-color: #82959f;}
    // ::v-deep .elx-header--column .elx-cell { color: #fff; }
    ::v-deep .elx-table .elx-header--column.col--ellipsis {height: auto;padding: 5px 0;}
    ::v-deep .el-checkbox {margin-top: 3px; margin-bottom: 3px;}
    .nodata {
            color: #ccc;
        }
</style>